import { Vessel } from ".";

export class BaseResults {
  searchId: string;
  total: number;
  items: Array<any>;

  constructor(json: any, accountType = '') {
    try {
      let data = json.data;
      let summary = data.summary;

      this.searchId = data.searchId;
      this.total = summary.count;
    } catch (ex) {
      this.setDefaults();
    }
  }

  setDefaults() {
    this.searchId = '';
    this.total = 0;

    this.items = [];
  }
}

export class VesselResults extends BaseResults {
  items: Array<Vessel>;

  constructor(json: any, accountType = '') {
    super(json);

    try {
      this.setItems(json.data.items, accountType);
    } catch (ex) {
      this.items = [];
    }
  }

  setItems(items: Array<any>, accountType: string) {
    this.items = [];

    try {
      for (let current = 0; current < items.length; current++) {
        this.items.push(new Vessel(items[current], accountType));
      }

      this.items.sort((a, b) => {
        let one = a.name.toUpperCase();
        let two = b.name.toUpperCase();
        return (one < two) ? -1 : (one > two) ? 1 : 0;
      });
    } catch (ex) {
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/models/results.ts